import { useCanvasClone } from './useCanvasClone';
import useFetchedEstimate from './useFetchedEstimate';

import { getIsDirtyState } from '~/core/helpers';

export const useCanvasImage = () => {
  const { canvasJpegUrl } = useCanvasClone();
  const { fetchedEstimate } = useFetchedEstimate();
  const isDirty = getIsDirtyState();
  const estimateDrawingUrl = fetchedEstimate?.estimateDrawingUrl;
  const shouldPrioritizeUrl = !!estimateDrawingUrl && !isDirty;

  return {
    canvasJpeg: shouldPrioritizeUrl
      ? estimateDrawingUrl
      : (canvasJpegUrl ?? estimateDrawingUrl ?? ''),
  };
};
